import { render, staticRenderFns } from "./Evaluations.vue?vue&type=template&id=64145eaf&scoped=true"
import script from "./Evaluations.vue?vue&type=script&lang=js"
export * from "./Evaluations.vue?vue&type=script&lang=js"
import style0 from "./Evaluations.vue?vue&type=style&index=0&id=64145eaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64145eaf",
  null
  
)

export default component.exports